import { logoutAnalytics } from '../services/firebase-auth.js';

export default function Header({ email }) {
  async function handleLogout() {
    await logoutAnalytics();
    window.location.assign('/');
  }

  return (
    <header className="analytics-topbar">
      <div className="analytics-topbar-copy">
        <span className="analytics-topbar-product">Analytics</span>
        {email ? <span className="analytics-topbar-email">{email}</span> : null}
      </div>
      <button type="button" className="analytics-btn analytics-btn-ghost" onClick={handleLogout}>
        Salir
      </button>
    </header>
  );
}
